import { addBreadcrumb } from './sentryClient';

/**
 * Detect-and-telemetry for silent HTTP redirects (spec §3.5). Observability
 * only — never changes request behavior. No-op until Sentry registers.
 * Query strings are stripped from breadcrumb data to avoid leaking params.
 */
const stripQuery = (url?: string): string | undefined => url?.split('?')[0];

export const addRedirectBreadcrumb = (
  source: 'rtk' | 'axios',
  requestUrl: string | undefined,
  finalUrl: string | undefined,
  redirectedFlag?: boolean,
): void => {
  try {
    const from = stripQuery(requestUrl);
    const to = stripQuery(finalUrl);
    // An authoritative boolean (Fetch's Response.redirected) always wins; the
    // URL comparison is only a fallback for clients that don't report the flag
    // (axios), so normalization quirks can't emit spurious breadcrumbs.
    const wasRedirected =
      typeof redirectedFlag === 'boolean' ? redirectedFlag : !!from && !!to && from !== to;
    if (!wasRedirected) return;
    addBreadcrumb({
      category: 'http.redirect',
      message: `[${source}] response was redirected`,
      level: 'info',
      data: { from, to },
    });
  } catch {
    // Intentionally silent: telemetry must never throw or alter
    // request/response flow (spec §3.5).
  }
};
